import React from "react";
import "./certificate.css";

const Certificate = () => {
  return (
    <div className="certificate">
      <div className="certificate__container">
        <img src="img/wt-certificate.jpg" alt="Wego strongest certificate" />
      </div>
    </div>
  );
};

export default Certificate;
